/*
 * Copyright (c) 2018-2023 MemberCenter, a subsidiary of Cameron Collective
 *   All Rights Reserved
 */
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useState } from 'react';

import { DiscountCodeForm, ProgressButton } from 'components';
import { useAddDiscountCodeMutation, useEditDiscountCodeMutation } from 'store/api/version-api.slice';

const AddDiscountCode = ({ onClose, open, discount_code }) => {
	const [formValues, setFormValues] = useState({
		name: discount_code ? discount_code.name : '',
		code: discount_code ? discount_code.code : '',
		percentage: discount_code ? discount_code.percentage : 0,
		recurring: discount_code ? discount_code.recurring : false
	});

	const [editDiscountCode, { isLoading: isEditLoading }] = useEditDiscountCodeMutation();
	const [addDiscountCode, { isLoading: isAddLoading }] = useAddDiscountCodeMutation();

	const handleChange = (prop, value) => {
		setFormValues(prev => ({
			...prev,
			[prop]: value
		}));
	};

	const resetForm = () => {
		setFormValues({
			name: '',
			code: '',
			percentage: 0,
			recurring: false
		});
	};

	const handleClose = () => {
		resetForm();
		onClose();
	};

	const handleSave = async () => {
		const values = { ...formValues };

		if (discount_code) {
			await editDiscountCode({ id: discount_code.id, payload: values });
		} else {
			await addDiscountCode(values);
		}
		handleClose();
	};

	const title = discount_code ? 'Edit Discount Code' : 'Add Discount Code';

	return (
		<Dialog
			maxWidth={'md'}
			fullWidth={true}
			open={open}
			onClose={handleClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
		>
			<DialogTitle id="alert-dialog-title">{title}</DialogTitle>
			<DialogContent>
				<DialogContentText id="alert-dialog-description">
					<DiscountCodeForm
						name={formValues.name}
						code={formValues.code}
						percentage={formValues.percentage}
						recurring={formValues.recurring}
						handlePropChange={handleChange}
						onSave={handleSave}
						onCancel={onClose}
					/>
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button variant="contained" color="inherit" onClick={handleClose}>
					Cancel
				</Button>
				<ProgressButton
					circleColor="secondary"
					button={
						<Button
							disabled={formValues.name.length === 0}
							onClick={handleSave}
							variant="contained"
							color="primary"
							autoFocus
						>
							Save
						</Button>
					}
					isLoading={isEditLoading || isAddLoading}
				/>
			</DialogActions>
		</Dialog>
	);
};
export default AddDiscountCode;
